import { useState, useCallback } from 'react';
import { VisibilityChangeCallback } from '@/features/submission_forms/types';

/**
 * Hook to track which form sections are currently visible
 * Used for navigation and progress display
 */
export const useVisibilityTracking = () => {
  const [visibleSections, setVisibleSections] = useState<Set<string>>(
    new Set()
  );

  const handleVisibilityChange: VisibilityChangeCallback = useCallback(
    (sectionId: string, isVisible: boolean) => {
      setVisibleSections(prev => {
        const newSet = new Set(prev);
        if (isVisible) {
          newSet.add(sectionId);
        } else {
          newSet.delete(sectionId);
        }
        return newSet;
      });
    },
    []
  );

  return { visibleSections, handleVisibilityChange };
};
